import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ContractForm from './components/ContractForm';
import Login from './components/Login';
import Header from './components/Header';
import { User } from './types/user';
import './App.css';

const App: React.FC = () => {
    const [userSession, setUserSession] = useState<User | null>(() => {
        const storedUser = localStorage.getItem('userData');
        return storedUser ? JSON.parse(storedUser) : null;
    });

    useEffect(() => {
        // Verificar la sesión cada vez que cambie
        if (!userSession) {
            localStorage.removeItem('userData');
        }
    }, [userSession]);

    const handleLogin = (user: User) => {
        setUserSession(user);
    };

    const handleLogout = () => {
        setUserSession(null);
        localStorage.removeItem('userData');
    };

    return (
        <BrowserRouter basename="">
            <div className="d-flex flex-column min-vh-100">
                {userSession && <Header user={userSession} onLogout={handleLogout} />}
                <div className="flex-grow-1">
                    <Routes>
                        {/* Ruta de login */}
                        <Route 
                            path="/login" 
                            element={!userSession ? <Login onLogin={handleLogin} /> : <Navigate to="/" />} 
                        />
                        
                        {/* Ruta principal de contratos (ruta por defecto) */}
                        <Route 
                            path="/" 
                            element={userSession ? <ContractForm /> : <Navigate to="/login" />} 
                        />

                        {/* Ruta para cualquier otra URL */}
                        <Route 
                            path="*" 
                            element={<Navigate to="/login" />} 
                        />
                    </Routes>
                </div>
            </div>
        </BrowserRouter>
    );
};

export default App; 